import fbAngrySvg from 'images/svg/fbReactions/angry.svg';
import fbLikeSvg from 'images/svg/fbReactions/like.svg';
import fbLoveSvg from 'images/svg/fbReactions/love.svg';
import fbHahaSvg from 'images/svg/fbReactions/haha.svg';
import fbSadSvg from 'images/svg/fbReactions/sad.svg';
import fbWowSvg from 'images/svg/fbReactions/wow.svg';

export type FbReactionId = 'angry' | 'like' | 'love' | 'haha' | 'sad' | 'wow';

export const FB_REACTIONS_ORDER: FbReactionId[] = [
  'angry',
  'like',
  'love',
  'haha',
  'sad',
  'wow',
];

export const FB_REACTION_SVGS: Record<FbReactionId, string> = {
  angry: fbAngrySvg,
  like: fbLikeSvg,
  love: fbLoveSvg,
  haha: fbHahaSvg,
  sad: fbSadSvg,
  wow: fbWowSvg,
};
